import React from 'react';
import _ from 'underscore';
import { Spinner, SpinnerSize } from '@bingads-webui-react/fabric-control';
import { Breadcrumbs } from '@bingads-webui-react/breadcrumbs';

import { DefaultUpdateEntityUrl } from './constants';
import { DefaultNodeRenderer } from './customer-account-node-renderer';
import { DummyAccountSelectorPropTypes } from './shapes';

// This is the CustomerAccountSelector component with all API calls removed to mimic the look only
// For complex state object, avoid PureComponent as it does shallow comparison of prev and new state
export class DummyCustomerAccountSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parentCustomerEntities: [],
      showSpinner: false,
    };
    this.enableSearchContext = false;
    this.config = {
      autoHeight: props.autoHeight,
      batchSize: props.batchSize,
      enableOnScrollLoad: props.enableOnScrollLoad,
      returnOnlyDirectlyLinkedEntities: props.returnOnlyDirectlyLinkedEntities,
    };
  }

  convertToBreadCrumbModel = (entities, url) => {
    /* istanbul ignore next */
    const list = _.map(entities, entity => ({
      key: entity.id && entity.id.toString(),
      text: entity.name,
      href: this.constructNodeUrl(entity, url),
    }));
    return list;
  };

  handleClick = () => {
    this.setState({ showSpinner: true });
  };

  render = () => {
    const url = this.props.routeLocation;
    // TODO: Placeholder until can switch this dummy component with the real component on click
    if (this.state.showSpinner) {
      return <Spinner size={SpinnerSize.Large} />;
    }

    return (
      <div role="button" tabIndex="0" onClick={this.handleClick} onKeyPress={this.handleClick}>
        <Breadcrumbs
          items={this.convertToBreadCrumbModel(this.state.parentCustomerEntities, url)}
          itemRenderer={this.props.breadcrumbItemRenderer}
        />
      </div>
    );
  }
}

DummyCustomerAccountSelector.propTypes = DummyAccountSelectorPropTypes;

DummyCustomerAccountSelector.defaultProps = {
  ccCustomerService: undefined,
  selectedEntity: undefined,
  i18n: undefined,
  rootCustomerId: undefined,
  userId: undefined,
  nodeRenderer: DefaultNodeRenderer,
  breadcrumbItemRenderer: undefined,
  updateEntityUrl: DefaultUpdateEntityUrl,
  cellHeight: _.noop(),
  showAccountSelectorView: false,
  overrideToggleEvent: false,
  ignoreFilter: true,
  inactiveAccountFilter: undefined,
  switchAccountsLabelClicked: _.noop(),
  batchSize: 1000,
  autoHeight: true,
  returnOnlyDirectlyLinkedEntities: false,
  enableOnScrollLoad: false,
};
